import { ILocatorOverrides } from '../../../types/utility';
import { createLocators } from '@u1/locators';
import React from 'react';
import clsx from 'clsx';
import useStyles from './Icon.styles';

export interface IIconProps extends ILocatorOverrides {
  /**
   * Certain icon as a component
   */
  icon: React.ComponentType;
  /**
   * Size of the icon
   */
  size?: number;
  /**
   * Custom class name
   */
  className?: string;
  /**
   * Custom css styles
   */
  style?: React.CSSProperties;
}

export const iconLocators = createLocators({
  name: 'Icon',
  componentLocators: ['icon'],
});

const { locators } = iconLocators();

const Icon: React.FC<IIconProps> = ({
  size = 20,
  className,
  style,
  locatorsOverrides,
  icon: Component,
}) => {
  const classes = useStyles();
  return (
    <div
      {...locators.icon()}
      {...locatorsOverrides}
      className={clsx(classes.root, className)}
      style={{ width: size, height: size, ...style }}
    >
      <Component />
    </div>
  );
};

export default Icon;
